import { Pipe, PipeTransform } from "@angular/core";
import { map } from "rxjs/operators";
import { ServiceType } from "src/app/model/run";
import { DispatchService } from "src/app/services/dispatch.service";

@Pipe({
  name: 'runServiceTypeName$'
})
export class RunServiceTypeNamePipe implements PipeTransform {
  public constructor(private service: DispatchService) { }

  public transform(value: ServiceType | ServiceType[]) {
    const ids = value instanceof Array
      ? value
      : [value];
    
    return this.service
      .serviceTypes$
      .pipe(
        map((types) => {
          return ids.reduce((names, serviceTypeId, index) => {
            const name = types.find((type) => type.id === serviceTypeId)?.name ?? '';
      
            if(index === 0) {
              return name;
            }
            else if(index + 1 === self.length) {
              return `${names} and ${name}`;
            }
            else {
              return `${names}, ${name}`;
            }
          }, '');
        })
      );
  }
}
